
import {throwError as observableThrowError,  Observable, map, BehaviorSubject } from 'rxjs';
import { Injectable } from "@angular/core";
import { partsModel } from "../models/partInfo";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { GlobalconfigService } from "../common/globalConfig.service";



const BASE_URL = "assets/api/json/";

@Injectable()
export class logbaseService {
  private formData=new BehaviorSubject<any>({});
  formDataSubject=this.formData.asObservable();
  constructor(private http: HttpClient, private config: GlobalconfigService) { 
    console.log("global config 3",this.config.baseApiUrl)

  }

  // getUserLoginDetails(data, token){
  //   let headers = new HttpHeaders();
  //   // headers = headers.append('Authorization', 'Bearer' + ' ' +token);
  //   return this.http.post(this.config.baseApiUrl + 'user/loginDetails', data, {headers: headers})
  // }


  
  setFormData(formData:any)
  {
     this.formData.next(formData);
  }
  getFormData()
  {
    return this.formDataSubject;
  }

 
  getUserLoginDetails(data) {
    console.log("get user login",this.config.baseApiUrl)
    return this.http.post(this.config.baseApiUrl + "user/loginDetails", data);
  }
  getRolesFromApi(userId): Observable<any>{
    return this.http.get(this.config.baseApiUrl + `getRoles/${userId}`,{});
  }

  getRoleDetails(data) {
    return this.http.post(this.config.baseApiUrl + "user/loginDetails", data);
  }
  // check existing EmailID
  checkexistingEmailID(dataToSend): Observable<any> {
    let forgotUserName =
      this.config.baseApiUrl +
      "userMaster/checkEmailIdExist" +
      "/" +
      dataToSend;
    return this.http.get(forgotUserName);
  }
  // Check Exisiting Login ID.
  checkexistingLoginID(dataToSend): Observable<any> {
    let forgotUserName = this.config.baseApiUrl + "user" + "/" + dataToSend;
    return this.http.get(forgotUserName);
  }
  // API for Forgot Username.
  forgotuserName(dataToSend): Observable<any> {
    let forgotUserName =
      this.config.baseApiUrl + "user/forgotUserName" + "/" + dataToSend;
    return this.http.get(forgotUserName);
  }

  // API for Forgot Password.
  forgotPassword(dataToSend): Observable<any> {
    let forgotPassword =
      this.config.baseApiUrl + "user/forgotPassword" + "/" + dataToSend;
    return this.http.get(forgotPassword);
  }

  //API for Supplier Management Table element
  getSupplierMasterData(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "supplierMaster");
  }

  getUrisForDownload(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "downloadpackage");
  }

  //API for Supplier Management Table element Paginated
  getSupplierMasterDataPaginated(data): Observable<any> {
    return this.http.post(
      this.config.baseApiUrl + "supplierMasterPaginated",
      data
    );
  }

  //API for Supplier Management Data ADD User
  createSupplierManagementUser(dataToSend): Observable<any> {
    let url = this.config.baseApiUrl + "supplierMasterUserUpdate";

    return this.http.post(url, dataToSend);
  }

  //API for Supplier Management Data ADD User
  createSupplierManagementUserPostCall(dataToSend): Observable<any> {
    let url = this.config.baseApiUrl + "supplierMasterUserUpdate";

    return this.http.post(url, dataToSend);
  }

  resetuserPassword(dataToSend): Observable<any> {
    let url = this.config.baseApiUrl + "user/resetPassword";
    //  return this.http.post(postPartInfoDataUrl, dataToSend);
    return this.http.put(url, dataToSend);
  }
  private extractData(res: Response) {
    let body = res.json();
    return body;
  }
  private handleError(error: any) {
    let errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return observableThrowError(errMsg);
  }

  // API to get all package Information
  getAllPackages(): Observable<any> {
    let getAllPackagesUrl =
      this.config.baseApiUrl + "packageMaster/approvedStatus";
    return this.http.get(getAllPackagesUrl);
  }

  // API to get all fuso package Information
  getAllFusoPackages(): Observable<any> {
    let getAllFusoPackagesUrl = this.config.baseApiUrl + "fusoPackageMaster";
    return this.http.get(getAllFusoPackagesUrl);
  }

  // API for USer Details
  getUserDetails(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "user");
  }

  // API for paginated USer Details
  getUserDetailsPaginated(pageObject): Observable<any> {
    return this.http.post(
      this.config.baseApiUrl + "user/paginated",
      pageObject
    );
  }
  // getNewPartsbyPkgId(pkg_id): Observable<any> {
  //     let getNewPartsbyPkgIdUrl = this.config.baseApiUrl + 'newPart/' + pkg_id;
  //     return this.http.get(getNewPartsbyPkgIdUrl);
  // }
  // API for USer Details
  singlegetUserDetails(user_id): Observable<any> {
    let singleUser = this.config.baseApiUrl + "user" + "/" + user_id;
    return this.http.get(singleUser);
  }
  // API for User Registeration
  create(dataToSend): Observable<any> {
    let url = this.config.baseApiUrl + "user";
    return this.http.post(url, dataToSend).pipe(map((res: Response) => res));
  }

  //API for activating deactivating user
  activation(dataToSend): Observable<any> {
    console.log("user base url",this.config.baseApiUrl)
    let url = this.config.baseApiUrl + "user" + "/" + "updateUserDetails";
    return this.http.post(url, dataToSend).pipe(map((res: Response) => res));
  }

  updateUserDetails(dataToSend) {
    // let updateUrl = this.config.baseApiUrl + "user/updateUserDetails";
    // return this.http.post(updateUrl, dataToSend).map((res: Response) => res);
    return this.http.post(
      this.config.baseApiUrl + "user/updateUserDetails",
      dataToSend
    );
  }

  // API to get new parts for notification Module
  getNewPartsNotification(): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userSuppCode = userDetJson.supplierCode.toString();

    if (userSuppCode == "ALL") {
      return this.http.get(this.config.baseApiUrl + "newPart/");
    } else {
      return this.http.get(
        this.config.baseApiUrl + "newPartEpics/" + userSuppCode.toString()
      );
    }
  }

  // API to get new parts for notification Module
  getNewPartsNotificationLineNumber(): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userLineNumber = userDetJson.lineNumbers.toString();
    return this.http.get(
      this.config.baseApiUrl +
      "newPartEpics/getNotificationforOperation/" +
      userLineNumber.toString()
    );
  }
  // API to get new parts
  getNewParts(): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userSuppCode = userDetJson.supplierCode;
    //userSuppCode.toString convert array into string separated by commas
    return this.http.get(
      this.config.baseApiUrl + "newPartEpics/" + userSuppCode.toString()
    );
  }

  // API to get new parts
  getNewPartStatus(userSuppCode): Observable<any> {
    // let userDetails = localStorage.getItem('userDetails');
    // let userDetJson = JSON.parse(userDetails);

    if (userSuppCode == "ALL") {
      return this.http.get(
        this.config.baseApiUrl + "newPartEpics/packageIdWithNewStatus"
      );
    } else {
      return this.http.get(
        this.config.baseApiUrl + "newPartEpics/newStatus/" + userSuppCode
      );
    }
  }

  // API to get new parts
  getNewStatusParts(): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userSuppCode = userDetJson.supplierCode[0];
    if (userSuppCode == "ALL") {
      return this.http.get(
        this.config.baseApiUrl + "newPartEpics/packageIdWithNewStatus"
      );
    } else {
      return this.http.get(
        this.config.baseApiUrl + "newPartEpics/newStatus/" + userSuppCode
      );
    }
  }

  // API to get parts information data
  getPartInfoData(dataToSend) {
    let getPartInfoDataUrl = this.config.baseApiUrl + "partInfo";
    return this.http.get(getPartInfoDataUrl + "/" + dataToSend);
  }

  // API to save new parts form
  savePartFormData(dataToSend) {
    let postPartInfoDataUrl = this.config.baseApiUrl + "partInfo";
    return this.http.post(postPartInfoDataUrl, dataToSend);
  }

  // API to get parts information data
  getSupplyInfoData(dataToSend) {
    let getSupplyInfoDataUrl = this.config.baseApiUrl + "supplyInfo";
    return this.http
      .get(getSupplyInfoDataUrl + "/" + dataToSend)
      .pipe(map((res: Response) => res));
  }

  // API to save new parts form
  saveSupplyFormData(dataToSend) {
    let postSupplyInfoDataUrl = this.config.baseApiUrl + "supplyInfo";
    return this.http.post(postSupplyInfoDataUrl, dataToSend);
  }

  // API to get parts information data
  getPackageInfoData(dataToSend) {
    let getPkgInfoDataUrl = this.config.baseApiUrl + "packageInfo";
    return this.http.get(getPkgInfoDataUrl + "/" + dataToSend);
  }

  savePkgFormData(dataToSend) {
    let postPkgInfoDataUrl = this.config.baseApiUrl + "packageInfo";
    return this.http.post(postPkgInfoDataUrl, dataToSend);
  }

  updatePackageStatus(dataToSend) {
    let updatePkgStatusUrl =
      this.config.baseApiUrl + "newPartEpics/updatePackageIdStatus ";
    return this.http.post(updatePkgStatusUrl, dataToSend);
  }
  getNewPartTodoList() {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;

    let userSuppCode = userDetJson.supplierCode;
    let suppCode = userSuppCode.toString();
    // if(suppCode != "ALL"){
    return this.http.get(
      this.config.baseApiUrl +
      "newPartEpics/todo/" +
      suppCode +
      "/" +
      userRoleId
    );
    // }
    // else {
    //     return this.http.get(this.config.baseApiUrl + "newPart" )
    // }
  }

  updateApprovedStatus(closedataToSend) {
    let updateApprovedStatusUrl =
      this.config.baseApiUrl + "newPartEpics/updateListOfPackageIdStatus";
    return this.http.post(updateApprovedStatusUrl, closedataToSend);
  }

  // API to get all package Information
  getPackageById(pkg_id): Observable<any> {
    let pkgID = encodeURIComponent(pkg_id);
    let getPackagesByIdUrl = this.config.baseApiUrl + "packageMaster/" + pkgID;
    return this.http.get(getPackagesByIdUrl);
  }

  // API to get all Fuso package Information by ID
  getFusoPackageById(pkg_id): Observable<any> {
    let getfusoPackagesByIdUrl =
      this.config.baseApiUrl + "fusoPackageMaster/" + pkg_id;
    return this.http.get(getfusoPackagesByIdUrl);
  }

  getNewPartsbyPkgId(pkg_id): Observable<any> {
    let getNewPartsbyPkgIdUrl = this.config.baseApiUrl + "newPart/" + pkg_id;
    return this.http.get(getNewPartsbyPkgIdUrl);
  }

  getPartStatusList(data) {
    return this.http.post(
      this.config.baseApiUrl + "newPartEpics/partStatus/paginated",
      data
    );
  }

  // API to get all Status of Active Packaging Requests
  getActivePackagingRequest(suppCode): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let roleID = userDetJson.userRoleMappings[0].roleId;
    // let suppliercode =  userDetJson.supplierCode;
    // let suppCode = suppliercode.toString();
    // let getAllActivePackagesUrl = this.config.baseApiUrl + "kpiReport/statusOfPackageId/currentQuarter/"+ suppCode + "/" + roleID
    return this.http.get(
      this.config.baseApiUrl +
      "kpiReport/statusOfPackageId/currentQuarter/" +
      suppCode.toString() +
      "/" +
      roleID
    );
  }
  // API to get all Status of Ratio of Standard vs Non-Standard Packaging
  getStatusStdvsNonstd(suppCode): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    // let suppliercode =  userDetJson.supplierCode;
    //let suppCode = suppliercode.toString();
    return this.http.get(
      this.config.baseApiUrl +
      "kpiReport/stdAndNonStdPackRatio/currentQuarter/" +
      suppCode.toString()
    );
  }
  // API to get all Status of Ratio of # of Parts with Lot Size ≠ Packaging Size
  getPartswithLotSize(suppCode): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let roleID = userDetJson.userRoleMappings[0].roleId;
    return this.http.get(
      this.config.baseApiUrl +
      "kpiReport/partLotSizeNotEqualpartInBox/" +
      suppCode.toString() +
      "/" +
      roleID
    );
  }

  partImgUpload(imgData, pkg_id): Observable<any> {
    let partImgUploadUrl = this.config.baseApiUrl + "partInfo/images/" + pkg_id;
    return this.http.post(partImgUploadUrl, imgData);
  }

  masterDataUpload(imgData, pkg_id): Observable<any> {
    let masterDataUploadUrl =
      this.config.baseApiUrl + "packageInfo/images/" + pkg_id;
    return this.http.post(masterDataUploadUrl, imgData);
  }

  packageDataUpload(fileData, user): Observable<any> {
    let masterDataUploadUrl =
      this.config.baseApiUrl + "/excel/upload/package/" + user;
    return this.http.post(masterDataUploadUrl, fileData);
  }
  kkUploadData(fileData, user): Observable<any> {
    let masterDataUploadUrl =
      this.config.baseApiUrl + "/excel/upload/kk/" + user;
    return this.http.post(masterDataUploadUrl, fileData);
  }
  partsUploadData(fileData, user): Observable<any> {
    let masterDataUploadUrl =
      this.config.baseApiUrl + "/excel/upload/parts/" + user;
    return this.http.post(masterDataUploadUrl, fileData);
  }

  getFilesData(fileType): Observable<any> {
    let masterDataUploadUrl =
      this.config.baseApiUrl + "/excel/" + fileType + "/detail";
    return this.http.get(masterDataUploadUrl);
  }

  // API to get all get ratio values for KPI Report StandardPackageQuaterRatio
  getKPIReportForStandardPackageQuaterRatio(suppCode): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let roleID = userDetJson.userRoleMappings[0].roleId;
    // return this.http.get(this.config.baseApiUrl + "kpiReport/stdPackageQuaterRatio/fusoPaid-suppPaid/"+ suppCode.toString() + "/" + roleID);
    // let userDetJson = JSON.parse(userDetails);
    // let roleID = userDetJson.userRoleMappings[0].roleId;
    return this.http.get(
      this.config.baseApiUrl +
      "kpiReport/stdPackageQuaterRatio/fusoPaid-suppPaid/" +
      suppCode +
      "/" +
      roleID
    );
  }
  deletePartImage(imgData, pkg_id): Observable<any> {
    let delPartImgUrl =
      this.config.baseApiUrl + "partInfo/images-files/" + pkg_id;
    return this.http.post(delPartImgUrl, imgData);
  }

  deletePackageImage(imgData, pkg_id): Observable<any> {
    let delPkgImgUrl =
      this.config.baseApiUrl + "packageInfo/images-files/" + pkg_id;
    return this.http.post(delPkgImgUrl, imgData);
  }

  getDeliveryPoints(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "deliveryPackageMaster");
  }

  saveDeliveryPoint(dataToSend) {
    let saveDelNameUrl = this.config.baseApiUrl + "deliveryPackageMaster";
    return this.http.post(saveDelNameUrl, dataToSend);
  }

  getSupplierCode(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "supplierMaster");
  }

  addSupplierCode(data) {
    let suppCode = this.config.baseApiUrl + "supplierMaster";
    return this.http.post(suppCode, data);
  }

  editSupplierCode(data) {
    return this.http.post(this.config.baseApiUrl + "supplierMaster", data);
  }

  getSupplierCodeDetail(suppCode): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "supplierMaster/" + suppCode);
  }

  getMissingSupplierCodes(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "missingSupplierCodes");
  }

  getVSList(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "vendorSchedulerMaster");
  }

  getMissingVSList(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "missingVendorCodes");
  }

  addVSUser(VSdata) {
    return this.http.post(
      this.config.baseApiUrl + "vendorSchedulerMaster",
      VSdata
    );
  }

  editVSUser(data) {
    return this.http.post(
      this.config.baseApiUrl + "vendorSchedulerMaster",
      data
    );
  }
  dataStatus(id){
   let params=new HttpParams().set('packageId',id)
    return this.http.get(
      this.config.baseApiUrl + "checkDataStatus",{params}
    );
  }

  //API for Supplier Management Dropdown element
  getAvailableSupplierCodesAndUsers(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "availableSupplierCodesAndUsers"
    );
  }

  // API for Forgot Username.
  getSupplierCodeDataSupplierManagement(dataToSend): Observable<any> {
    let SupplierCodeValue =
      this.config.baseApiUrl + "supplierMaster" + "/" + dataToSend;
    return this.http.get(SupplierCodeValue);
  }

  // API to get plant name using delivery point
  fetchPlantName(delPoint): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "deliveryPackageMaster/" + delPoint
    );
  }

  // API to get vscode details
  fetchvsdetails(vscode): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "vendorSchedulerMaster/" + vscode
    );
  }

  // API to get vscode details
  fetchSupplierName(suppCode): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "supplierMaster/" + suppCode);
  }

  // API to get missing delivery points
  fetchMissingDP(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "missingDeliveryCodes");
  }

  checkDeliveryPoint(dp): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "deliveryPackageMaster/" + dp
    );
  }
  getLineNumbers(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "lineNumberMaster/lineNumber"
    );
  }
  getSuppLineNumbers(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "lineNumberMaster/lineNumbers"
    );
  }
  getListofLineNumbers(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "lineNumberMaster/lineNumber"
    );
  }
  getMissingLineNumbers(data): Observable<any> {
    return this.http.post(
      this.config.baseApiUrl + "missingLineNumber/paginated",
      data
    );
  }

  getAvailableNextProcess(data) {
    return this.http.get(
      this.config.baseApiUrl +
      "lineNumberMaster/findLineNumbersByStatus/" +
      data
    );
  }

  updateNextProcessStatus(data) {
    return this.http.post(
      this.config.baseApiUrl + "lineNumberMaster/lineNumberPost",
      data
    );
  }

  addLineNumber(data) {
    return this.http.post(
      this.config.baseApiUrl + "lineNumberMaster/lineNumber",
      data
    );
  }

  addLineNumberMissing(data) {
    return this.http.post(
      this.config.baseApiUrl + "missingLineNumberPost",
      data
    );
  }

  getTodoByLineNumbers(lineNum): Observable<any> {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;
    return this.http.get(
      this.config.baseApiUrl +
      "newPartEpics/todoByLineNumber/" +
      lineNum +
      "/" +
      userRoleId
    );
  }
  partStatusByLineNo(lineNo, roleId): Observable<any> {
    var lineNoString;
    if (lineNo != null || lineNo != "") {
      lineNoString = lineNo.toString();
    } else {
      lineNoString = null;
    }
    return this.http.get(
      this.config.baseApiUrl +
      "newPartEpics/partStatusByLineNum/" +
      lineNoString +
      "/" +
      roleId
    );
  }

  getNewPartsPage(data) {
    return this.http.post(
      this.config.baseApiUrl + "newPartEpics/newStatus/paginated",
      data
    );
  }

  partStatusWtPaging(data) {
    return this.http.post(
      this.config.baseApiUrl + "newPartEpics/partStatus/paginated",
      data
    );
  }
  

  getNewPartsTodoPaginated(data) {
    return this.http.post(
      this.config.baseApiUrl + "newPartEpics/todo/partStatus/paginated",
      data
    );
  }

  // getApprovePartsPage(data) {
  //     return this.http.post(this.config.baseApiUrl + 'newPartEpics/partStatus/paginated', data)

  // getApprovePartsPage(data) {
  //     return this.http.post(this.config.baseApiUrl + 'newPartEpics/partStatus/paginated', data)

  // }
  getApprovePartsPage(data) {
    return this.http.post(
      this.config.baseApiUrl +
      "newPartEpics/supplierDatabase/partStatus/paginated",
      data
    );
  }
  getApprovedAddressPage(data) {
    return this.http.post(
      this.config.baseApiUrl + "newPartEpics/supplyInfo/prodInfoAndShipInfo",
      data
    );
  }
  preflightMode(testString) {
    return this.http.get(this.config.baseApiUrl + "user/test/" + testString);
  }

  searchByPartNumber(data) {
    return this.http.post(
      this.config.baseApiUrl + "newPartEpics/searchByPartNumberAndLineNumber",
      data
    );
  }

  searchProcessCode(data) {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;
    return this.http.post(
      this.config.baseApiUrl +
      "assemblyLineOpView/searchByPartNumberAndLineNum",
      data
    );
  }

  saveProcessCode(data) {
    return this.http.post(this.config.baseApiUrl + "assemblyLineOpView", data);
  }

  getPartIdentifier(data) {
    return this.http.get(this.config.baseApiUrl + "assemblyLineOpView/" + data);
  }

  getSupplierDatabaseLineNumbers(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "newPartEpics/lineNumbers/approved"
    );
  }
  getSupplierDatabaseDeliveryPoint(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "newPartEpics/deliveryPoint/approved"
    );
  }

  registerL4Users(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "userMaster/allDetailsOfAvailableRegUsers"
    );
  }

  getSupplierCodeAddress(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "supplierMaster/supplierCodes"
    );
  }
  getSupplierNameAddress(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "supplierMaster/supplierEName"
    );
  }
  getL4SmQ(datatoSend): Observable<any> {
    return this.http.get(
      // this.config.baseApiUrl +
      // "kpiReport/level4Manager/associated-todoUserStatusChart/" +
      // datatoSend

      this.config.baseApiUrl +
      "kpiReport/level4Manager/associated-todoUserStatusChart/" +
      datatoSend
    );
  }

  getKPIL4DataonLoad(datatoSend): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl +
      "kpiReport/level4Manager/todoUserStatusChart/" +
      datatoSend
    );
  }

  getGroupNo(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "GroupNumberMaster/groupNumber"
    );
  }

  saveGroupNo(data) {
    return this.http.post(
      this.config.baseApiUrl + "GroupNumberMaster/groupNumber",
      data
    );
  }

  getPoDailyData() {
    return this.http.get(this.config.baseApiUrl + "pocycle");
  }

  getPOSupplierCode(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "supplierMaster");
  }

  getAllPoData() {
    // let suppCode = suppCodeData.toString();
    // return this.http.get(
    //   this.config.baseApiUrl +
    //     "pocycle/getPoForListOfSupplier/{supplierCodeList}/{cycle}"
    // );
  }
  getPODataSupp() {
    return this.http.get(
      this.config.baseApiUrl +
      "pocycle/getPoForOneSupplier/{supplierCode}/{cycle}"
    );
  }
  //Get All Group number
  getGroupNumberMasterData(): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "GroupNumberMaster/groupNumber"
    );
  }

  lineWorkerTodo(data) {
    return this.http.post(
      this.config.baseApiUrl +
      "assemblyLineOpView/lineWorkerViewBasedOnLineNum&GroupNo",
      data
    );
  }

  submitRevisionRequest(data) {
    return this.http.post(
      this.config.baseApiUrl + "revisionRequest/createRevisionRequest",
      data
    );
  }

  getRevRequestedPkg() {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let suppliercode = userDetJson.supplierCode;
    // let suppCode = suppliercode.toString();
    return this.http.get(
      this.config.baseApiUrl +
      "revisionRequest/getSupplierCodewiseRevisionRequest/" +
      suppliercode
    );
  }

  getRequestedPkg() {
    return this.http.get(
      this.config.baseApiUrl + "revisionRequest/getRevisionRequestBystatus"
    );
  }

  changeRevisionStatus(data) {
    return this.http.post(
      this.config.baseApiUrl + "revisionRequest/updateRevisionRequest",
      data
    );
  }

  userEmailDetails(supplircode, roldId) {
    return this.http.get(
      this.config.baseApiUrl +
      "/userMaster/listUsernameAndEmailForPackageId/" +
      supplircode +
      "/" +
      roldId
    );
  }

  getLineNumberbyGroupNumber(groupId) {
    return this.http.get(
      this.config.baseApiUrl +
      "/lineNumberMaster/findLineNumbersByGroupId/" +
      groupId
    );
  }

  getFcMonthlyData(data) {
    return this.http.post(
      this.config.baseApiUrl + "forcastMonthlyView/paginatedForcastDetails",
      data
    );
  }

  getFcDailyData(data) {
    return this.http.post(
      this.config.baseApiUrl + "forecastDayWiseTableView/paginatedForcast",
      data
    );
  }

  fetchPlantPO() {
    return this.http.get(
      this.config.baseApiUrl + "deliveryPointMaster/deliveryPoint-plantNames"
    );
  }

  MaintanenceScheduler(data) {
    return this.http.post(this.config.baseApiUrl + "Maintenance", data);
  }

  getMaintainenceHistory(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "Maintenance");
  }

  deleteMaintainenceinput(id): Observable<any> {
    return this.http.delete(this.config.baseApiUrl + "Maintenance/" + id);
  }

  PoDailyListData(data) {
    return this.http.post(
      this.config.baseApiUrl + "forecastDayView/paginatedForcast",
      data
    );
  }

  getLocationList() {
    return this.http.get(
      this.config.baseApiUrl + "deliveryPointMaster/deliveryPoint-plantNames"
    );
  }

  getFcJunData(data) {
    return this.http.post(
      this.config.baseApiUrl + "forecastCycleView/paginatedForcast",
      data
    );
  }

  untagSupplier(data) {
    return this.http.post(
      this.config.baseApiUrl + "userMaster/untagSupplier",
      data
    );
  }

  missingSupplierCodePaginated(data) {
    return this.http.post(
      this.config.baseApiUrl + "missingSupplierCode/paginated",
      data
    );
  }

  updateMissingSupplierCode(data) {
    return this.http.post(this.config.baseApiUrl + "missingSupplierCode", data);
  }

  missingDeliveryPointPaginated(data) {
    return this.http.post(
      this.config.baseApiUrl + "missingDeliveryPoint/paginated",
      data
    );
  }

  updateMissingDeliveryPoint(data) {
    return this.http.post(
      this.config.baseApiUrl + "missingDeliveryPointPost",
      data
    );
  }

  getMissingVSVodePaginated(data) {
    return this.http.post(this.config.baseApiUrl + "missingVS/paginated", data);
  }

  updateMissingVS(data) {
    return this.http.post(this.config.baseApiUrl + "/missingVS", data);
  }

  logoutUser(loginId) {
    return this.http.get(
      this.config.baseApiUrl + "userMaster/logout/" + loginId
    );
  }

  packageLockUnlock(data) {
    return this.http.get(
      this.config.baseApiUrl +
      "newPartEpics/getEnableDisablePackageID/" +
      data.pkgStatus +
      "/" +
      data.pkgId
    );
  }
  getUserStatisticsData() {
    return this.http.get(this.config.baseApiUrl + "userMaster/userStatitics");
  }

  getUserForCSV() {
    return this.http.get(this.config.baseApiUrl + "userToCSV");
  }

  //This api for All Supplier code and Location code too for Day cycle
  getAllSupplierCode(data) {
    return this.http.post(
      this.config.baseApiUrl + "supplierLocationDay/suppplierLocList",
      data
    );
  }

  //This api for All Supplier code and Location code too for June cycle
  getAllSupplierJuneCode(data) {
    return this.http.post(
      this.config.baseApiUrl + "supplierLocationCycle/suppplierLocList",
      data
    );
  }

  getPoSummaryData(data) {
    return this.http.post(
      this.config.baseApiUrl + "forcastCountView/paginated",
      data
    );
  }

  //This api for All Supplier code and Location code too for Monthly cycle
  getAllSupplierMonthlyCode(data) {
    return this.http.post(
      this.config.baseApiUrl + "supplierLocationMonthly/suppplierLocList",
      data
    );
  }

  monthlyGraphView(suppID) {
    return this.http.get(
      this.config.baseApiUrl + "forcastMonthlyView/" + suppID
    );
  }

  junGraphView(suppID) {
    return this.http.get(
      this.config.baseApiUrl + "forecastCycleView/" + suppID
    );
  }

  dailyGraphView(suppID) {
    return this.http.get(
      this.config.baseApiUrl + "forecastDaySupplierCodeWiseView/" + suppID
    );
  }

  getPoFixedDaily(data) {
    return this.http.post(
      this.config.baseApiUrl + "poFixedPackageIdWiseView/paginatedForcast",
      data
    );
  }

  getExport1Data() {
    return this.http.get(this.config.baseApiUrl + "poFixExportOne");
  }

  getExport2Data() {
    return this.http.get(this.config.baseApiUrl + "/poFixedAndMergeExportTwo");
  }

  getSuppProcessCodeURL() {
    return this.http.get(this.config.baseApiUrl + "/supplyProcessCodeExport");
  }

  addSuppCodeException(data) {
    return this.http.post(this.config.baseApiUrl + "updateSPCDelPoint", data);
  }

  getSPCException(data) {
    return this.http.post(
      this.config.baseApiUrl + "paginatedNoubaListDetails",
      data
    );
  }

  delSPCException(data): Observable<any> {
    let delPoint = data.deliveryPoint;
    return this.http.delete(
      this.config.baseApiUrl + "deleteSPCNouba/" + delPoint
    );
  }

  getAllPrefectures(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "/supplierregion");
  }

  addPrefecture(data) {
    return this.http.post(this.config.baseApiUrl + "/supplierregion", data);
  }

  editPrefecture(data) {
    return this.http.post(this.config.baseApiUrl + "/supplierregion", data);
  }

  deletePrefecture(id) {
    return this.http.delete(this.config.baseApiUrl + "/supplierregion/" + id);
  }

  getOnePrefecture(prefectureId): Observable<any> {
    return this.http.get(
      this.config.baseApiUrl + "/supplierregion/fetchById?id=" + prefectureId
    );
  }

  getServiceProviders(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "/serviceprovider");
  }
  postServiceProvider(serviceProvider: any): Observable<any> {
    return this.http.post(this.config.baseApiUrl + "/serviceprovider", serviceProvider);
  }
  deleteServiceProvider(id: any): Observable<any> {
    return this.http.delete(this.config.baseApiUrl + "/serviceprovider/" + id);
  }

  getNoubaPattern(): Observable<any> {
    return this.http.get(this.config.baseApiUrl + "/nouba/pattern/findAll")
  }

  editNoubaPattern(nouba: any): Observable<any> {
    return this.http.put(this.config.baseApiUrl + "/nouba/pattern/edit", nouba)
  }

}
